export enum ActionItemStatus {
    Scheduled = 0,
    Pending = 1,
    Verify = 2,
    Complete = 3,
    Void = 4,
    Defer = 5
}